"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EpochRewardsWrapper = void 0;
var fixidity_1 = require("@celo/utils/lib/fixidity");
var BaseWrapper_1 = require("./BaseWrapper");
var parseFixidity = function (v) { return (0, fixidity_1.fromFixed)((0, BaseWrapper_1.valueToBigNumber)(v)); };
var EpochRewardsWrapper = /** @class */ (function (_super) {
    __extends(EpochRewardsWrapper, _super);
    function EpochRewardsWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRewardsMultiplierParameters = (0, BaseWrapper_1.proxyCall)(_this.contract.methods.getRewardsMultiplierParameters, undefined, function (res) { return ({
            max: parseFixidity(res[0]),
            underspendAdjustment: parseFixidity(res[1]),
            overspendAdjustment: parseFixidity(res[2]),
        }); });
        _this.getTargetVotingYieldParameters = (0, BaseWrapper_1.proxyCall)(_this.contract.methods.getTargetVotingYieldParameters, undefined, function (res) { return ({
            target: parseFixidity(res[0]),
            max: parseFixidity(res[1]),
            adjustment: parseFixidity(res[2]),
        }); });
        _this.getCommunityReward = (0, BaseWrapper_1.proxyCall)(_this.contract.methods.getCommunityRewardFraction, undefined, parseFixidity);
        _this.getCarbonOffsetting = function () { return __awaiter(_this, void 0, void 0, function () {
            var factor, _a, partner;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = parseFixidity;
                        return [4 /*yield*/, this.contract.methods.getCarbonOffsettingFraction().call()];
                    case 1:
                        factor = _a.apply(void 0, [_b.sent()]);
                        return [4 /*yield*/, this.contract.methods.carbonOffsettingPartner().call()];
                    case 2:
                        partner = _b.sent();
                        return [2 /*return*/, {
                                factor: factor,
                                partner: partner,
                            }];
                }
            });
        }); };
        _this.getTargetValidatorEpochPayment = (0, BaseWrapper_1.proxyCall)(_this.contract.methods.targetValidatorEpochPayment, undefined, BaseWrapper_1.valueToBigNumber);
        return _this;
    }
    EpochRewardsWrapper.prototype.getConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rewardsMultiplier, carbonOffsetting, communityReward, targetVotingYield, targetValidatorEpochPayment;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRewardsMultiplierParameters()];
                    case 1:
                        rewardsMultiplier = _a.sent();
                        return [4 /*yield*/, this.getCarbonOffsetting()];
                    case 2:
                        carbonOffsetting = _a.sent();
                        return [4 /*yield*/, this.getCommunityReward()];
                    case 3:
                        communityReward = _a.sent();
                        return [4 /*yield*/, this.getTargetVotingYieldParameters()];
                    case 4:
                        targetVotingYield = _a.sent();
                        return [4 /*yield*/, this.getTargetValidatorEpochPayment()];
                    case 5:
                        targetValidatorEpochPayment = _a.sent();
                        return [2 /*return*/, {
                                rewardsMultiplier: rewardsMultiplier,
                                carbonOffsetting: carbonOffsetting,
                                communityReward: communityReward,
                                targetVotingYield: targetVotingYield,
                                targetValidatorEpochPayment: targetValidatorEpochPayment,
                            }];
                }
            });
        });
    };
    return EpochRewardsWrapper;
}(BaseWrapper_1.BaseWrapper));
exports.EpochRewardsWrapper = EpochRewardsWrapper;
//# sourceMappingURL=EpochRewards.js.map